

import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
const baseUrl = process.env.REACT_APP_BACKEND_BASE_URL || 'http://localhost:5000';
// Async thunk
export const resetPasswordRequest = createAsyncThunk(
  'resetPassword/send',
  async ({ otp, newPassword }, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${baseUrl}/users/normal/reset-password`, {
        otp,
        newPassword,
      });
      return response.data.message;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || error.message || 'Something went wrong'
      );
    }
  }
);

const resetPasswordSlice = createSlice({
  name: 'resetPassword',
  initialState: {
    loading: false,
    message: '',
    error: '',
  },
  reducers: {
    clearResetState: (state) => {
      state.loading = false;
      state.message = '';
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(resetPasswordRequest.pending, (state) => {
        state.loading = true;
        state.message = '';
        state.error = '';
      })
      .addCase(resetPasswordRequest.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload;
        state.error = '';
      })
      .addCase(resetPasswordRequest.rejected, (state, action) => {
        state.loading = false;
        state.message = '';
        state.error = action.payload;
      });
  },
});

export const { clearResetState } = resetPasswordSlice.actions;
export default resetPasswordSlice.reducer;
